module.exports = __webpack_public_path__ + "img/battery-2.cd95a1e7.svg";